import React, { useState } from 'react';

const SECTION_LIST = [
  'PENDAHULUAN',
  'DEFINISI',
  'UMUM',
  'PERSETUJUAN DATA PENGGUNA',
  'PERUBAHAN',
  'PENGGUNAAN DATA',
  'PENYIMPANAN & KEAMANAN DATA',
  'HAK PENGGUNA',
  'PERNYATAAN DAN JAMINAN ANDA',
  'LARANGAN PENGGUNAAN',
  'BIAYA DAN PEMBAYARAN',
  'HAK KEKAYAAN INTELEKTUAL',
  'BATAS TANGGUNG JAWAB',
  'KEADAAN MEMAKSA',
  'PENGAKUAN',
  'HUKUM YANG BERLAKU DAN PENYELESAIAN SENGKETA',
  'CARA MENGHUBUNGI KAMI',
];

interface SmartsecureTermsPageProps {
  isModal?: boolean;
}

const SmartsecureTermsPage: React.FC<SmartsecureTermsPageProps> = ({ isModal = false }) => {
  const [openSection, setOpenSection] = useState<number | null>(0);

  <CollapsibleSection
    title="DEFINISI"
    open={openSection === 1}
    onClick={() => handleToggle(1)}
  >
    <p>
      Dalam Syarat dan Ketentuan ini, istilah-istilah berikut memiliki arti
      sebagai berikut:
    </p>
    <ol className="list-decimal pl-5 space-y-2">
      <li>
        Layanan berarti layanan perangkat lunak dengan nama Smartsecure (powered
        by Whalebone) selaku teknologi Perlindungan Identitas, yang digunakan
        untuk memantau kebocoran data Pengguna
      </li>
      <li>
        Pengguna atau Anda berarti setiap pelanggan atau entitas yang
        menggunakan Layanan.
      </li>
      <li>
        Data Pribadi berarti sebagaimana didefinisikan dalam Undang-Undang
        Pelindungan Data Pribadi No 27 tahun 2022 berikut setiap peraturan
        pelaksanaan dan perubahannya.
      </li>
    </ol>
  </CollapsibleSection>;
  const handleToggle = (idx: number) => {
    setOpenSection(openSection === idx ? null : idx);
  };

  return (
    <div className={isModal ? "" : "min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 text-slate-900"}>
      <div className={isModal ? "" : "mx-auto max-w-5xl px-4 py-10"}>
        <main className={isModal ? "p-4" : "rounded-2xl bg-white p-6 shadow-lg ring-1 ring-slate-200"}>
          <h1 className={`text-2xl font-bold text-center mb-8 text-slate-800 tracking-tight ${isModal ? "hidden" : ""}`}>
            Syarat &amp; Ketentuan Layanan Smartsecure
          </h1>
          <p>Saya setuju dan dengan ini memberikan wewenang kepada PT XLSMART Telecom Sejahtera Tbk untuk membagikan 
            data pribadi saya kepada Sevencyber dan Whalebone yang diperlukan untuk 
            tujuan program SMARTSECURE powered by Whalebone</p>
            <br />
          <div className="divide-y divide-slate-200">
            <CollapsibleSection
              title="PENDAHULUAN"
              open={openSection === 0}
              onClick={() => handleToggle(0)}
            >
              <p>
                Dengan berlangganan layanan smartsecure melalui aplikasi my
                smartfren atau mySF (“mySF”), anda menyatakan telah membaca,
                memahami, dan menyetujui seluruh syarat-syarat dan
                ketentuan-ketentuan di bawah ini, berikut setiap perubahan atau
                modifikasinya dari waktu ke waktu (“Syarat dan Ketentuan”)
              </p>
            </CollapsibleSection>
            <CollapsibleSection
              title="DEFINISI"
              open={openSection === 1}
              onClick={() => handleToggle(1)}
            >
              <p>
                Dalam Syarat dan Ketentuan ini, istilah-istilah berikut memiliki
                arti sebagai berikut:
              </p>
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Layanan berarti layanan perangkat lunak dengan nama
                  Smartsecure (powered by Whalebone) selaku teknologi
                  Perlindungan Identitas, yang digunakan untuk memantau
                  kebocoran data Pengguna
                </li>
                <li>
                  Pengguna atau Anda berarti setiap pelanggan atau entitas yang
                  menggunakan Layanan.
                </li>
                <li>
                  Data Pribadi berarti sebagaimana didefinisikan dalam
                  Undang-Undang Pelindungan Data Pribadi No 27 tahun 2022
                  berikut setiap peraturan pelaksanaan dan perubahannya.
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="UMUM"
              open={openSection === 2}
              onClick={() => handleToggle(2)}
            >
              <p>
                Layanan dapat digunakan oleh pengguna yang memenuhi kriteria dan
                telah mengaktifkan Layanan melalui aplikasi atau platform yang
                di tentukan.
              </p>
              <p>
                Pengguna memahami dan menyetujui bahwa Layanan disediakan
                melalui Smartfren dan/atau aplikasi Smartfren dan/atau beberapa
                layanan seperti (namun tidak terbatas pada) Dukungan Pelanggan
                dan pembayaran dilakukan oleh Smartfren.
              </p>
              <p>
                Pengguna memahami dan menyetujui bahwa layanan disediakan oleh
                oleh PT Siber Tujuh Teknologi sebagai penyedia Layanan yang
                bekerja sama dengan Whalebone.s.r.o sebagai perusahaan yang
                mengembangkan teknologi untuk mendukung Layanan, dengan PT
                XLSMART Telecom Sejahtera Tbk (“XLSMART”) sebagai penyedia
                platform perantara mySF dalam memberikan layanan pendukung untuk
                melakukan proses pendaftaran dan transaksi berlangganan atas
                Layanan PT Siber Tujuh Teknologi dan Whalebone selanjutnya
                bersama-sama disebut sebagai “”Mitra.”
              </p>
              <p>
                Layanan ini tidak dapat dibatalkan dan dana tidak dapat
                dikembalikan. Pengguna dapat mengajukan berhenti berlangganan
                Layanan melalui layanan pelanggan atau call center
              </p>
              <p>
                Mitra berwenang untuk melakukan pembatasan penggunaan Layanan
                termasuk namun tidak terbatas pada :
              </p>
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  pengembalian biaya berlangganan dengan konsekuensi pembatalan
                  Layanan;
                </li>
                <li>penahanan dana;</li>
                <li>
                  penutupan akun Pengguna tanpa pemberitahuan sebelumnya;
                  dan/atau
                </li>
                <li>
                  tindakan lain sebagaimana diperlukan untuk sementara atau
                  untuk selamanya, dalam hal diduga dan/atau terdapat tindakan
                  Pengguna yang terindikasi melakukan kecurangan dan/atau
                  tindakan lain yang melanggar ketentuan Syarat dan Ketentuan
                  ini, dan/atau Syarat dan Ketentuan yang dikeluarkan oleh
                  aplikasi mySF dan/atau ketentuan hukum yang berlaku di wilayah
                  negara Republik Indonesia.
                </li>
              </ol>
              <p>
                Pengguna memahami dan menyetujui bahwa setiap kerugian yang
                timbul akibat dari tindakan tersebut di atas, termasuk namun
                tidak terbatas pada klaim, somasi, gugatan, tuntutan dan/atau
                upaya lainnya yang diajukan oleh Pengguna atau pihak ketiga,
                bukan merupakan tanggung jawab Mitra berwenang.
              </p>
            </CollapsibleSection>
            <CollapsibleSection
              title="PERSETUJUAN DATA PENGGUNA"
              open={openSection === 3}
              onClick={() => handleToggle(3)}
            >
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Dengan membeli dan/atau terus mengggunakan Layanan, Pengguna
                  dengan ini menyatakan telah membaca, memahami, dan menyetujui
                  Syarat dan Ketentuan ini secara keseluruhan, termasuk
                  memberikan persetujuan kepada Mitra dan pihak berwenang untuk
                  menyimpan informasi miliknya dan/atau data terkait penggunaan
                  Layanan dalam sistem.
                </li>
                <li>
                  Pengguna secara tegas memberikan persetujuan atas pengumpulan,
                  penyimpanan, dan penggunaan Data Pribadi miliknya sesuai
                  dengan Syarat dan Ketentuan ini serta dan ketentuan hukum
                  perlindungan data yang berlaku.
                </li>
                <li>
                  Pengguna mengakui bahwa persetujuan yang diberikan berdasarkan
                  artikel ini dapat ditarik kembali sewaktu-waktu, dengan
                  konsekuensi bahwa penarikan persetujuan tersebut dapat
                  memengaruhi ketersediaan dan fungsionalitas Layanan.
                </li>
                <li>
                  Pengguna dengan ini menyetujui kebijakan privasi atas Layanan
                  pada{' '}
                  <a
                    href="https://landing.smartsecureidp.com/terms-of-use"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    https://landing.smartsecureidp.com/terms-of-use
                  </a>
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="PERUBAHAN"
              open={openSection === 4}
              onClick={() => handleToggle(4)}
            >
              <p>
                Smartfren berhak untuk mengubah seluruh atau sebagian Syarat dan
                Ketentuan ini sewaktu-waktu sesuai permintaan dari penyedia
                layanan, tanpa pemberitahuan terlebih dahulu kepada Pengguna.
                Pengguna disarankan untuk membaca dan mengulas Ketentuan ini
                secara berkala untuk mengetahui setiap perubahan yang mungkin
                terjadi. Dengan tetap menggunakan Layanan setelah dilakukan
                perubahan atau pembaruan, Pengguna dianggap telah membaca,
                memahami, dan menyetujui Syarat dan Ketentuan terbaru yang
                berlaku.
              </p>
            </CollapsibleSection>
            <CollapsibleSection
              title="PENGGUNAAN DATA"
              open={openSection === 5}
              onClick={() => handleToggle(5)}
            >
              <p>
                Pengguna menyetujui pengungkapan Data Pribadi milik Pengguna
                berupa ‘email’ dan ‘nomor handphone’ kepada Mitra dan pihak
                berwenang lainnya.
              </p>
              <p>
                Mitra memiliki kewenangan untuk menolak atau menghapus secara
                sebagian maupun keseluruhan dari profil Pengguna dan data yang
                relevan yang dianggap melanggar Syarat dan Ketentuan atau
                ketentuan hukum yang berlaku.
              </p>
              <p>
                Setiap data/informasi yang diberikan oleh Pengguna pada saat
                proses pengajuan berlangganan melalui aplikasi mySF tunduk pada
                syarat-syarat dan ketentuan-ketentuan penggunaan platform
                Smartfren (
                <a
                  href="https://www.xlsmart.co.id/id/pemberitahuan-privasi/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline"
                >
                  https://www.xlsmart.co.id/id/pemberitahuan-privasi/
                </a>
                ) dan ketentuan yang diberlakukan oleh masing-masing penyedia
                jasa pembayaran yang telah bekerjasama dengan Smartfren.
              </p>
              <p>
                Data Pribadi digunakan untuk tujuan, antara lain namun tidak
                terbatas pada, hal hal berikut:
              </p>
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Melakukan aktivasi, penyediaan, dan pengelolaan Layanan.
                </li>
                <li>
                  Melakukan komunikasi dengan Pengguna terkait Layanan, termasuk
                  namun tidak terbatas pada peringatan keamanan, notifikasi
                  layanan, dan pembaruan.
                </li>
                <li>
                  Memberikan Customer Support kepada pengguna untuk layanan
                  Smartsecure
                </li>
                <li>
                  Melaksanakan analisis internal dan peningkatan kualitas
                  Layanan.
                </li>
                <li>
                  Mencegah terjadinya penipuan, penyalahgunaan, atau akses tidak
                  sah terhadap Layanan.
                </li>
                <li>
                  Memenuhi kewajiban hukum, peraturan, maupun kontraktual yang
                  berlaku.
                </li>
                <li>
                  Mengembangkandan meningkatkan fitur, kinerja, serta keamanan
                  Layanan.
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="PENYIMPANAN & KEAMANAN DATA"
              open={openSection === 6}
              onClick={() => handleToggle(6)}
            >
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Data pribadi disimpan menggunakan standar keamanan yang wajar
                  dan sesuai dengan ketentuan yang berlaku.
                </li>
                <li>
                  Mitra akan memproses Data Pribadi Pengguna, termasuk alamat
                  email dan nomor telepon, dan akan menyimpan Data Pribadi
                  tersebut selama Pengguna menggunakan Layanan.
                </li>
                <li>
                  Mitra akan mengambil Langkah yang wajar untuk melindungi Data
                  Pribadi dari akses, penggunaan, atau pengungkapan yang tidak
                  sah.
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="HAK PENGGUNA"
              open={openSection === 7}
              onClick={() => handleToggle(7)}
            >
              <p>
                Pengguna memiliki hak-hak berikut sehubungan dengan Data Pribadi
                mereka, sesuai dengan perarturan perundang-undangan yang
                berlaku:
              </p>
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Hak Akses – untuk meminta akses dan memperoleh salinan Data
                  Pribadi yang diproses oleh Layanan.
                </li>
                <li>
                  Hak Perbaikan – untuk meminta perbaikan atau pembaruan atas
                  Data Pribadi yang tidak akurat atau tidak lengkap.
                </li>
                <li>
                  Hak Penghapusan – untuk meminta penghapusan Data Pribadi,
                  dengan tunduk pada hukum dan peraturan yang berlaku.
                </li>
                <li>
                  Hak Menarik Persetujuan – untuk mencabut persetujuan atas
                  penggunaan Data Pribadi kapan saja, dengan memahami bahwa
                  pencabutan tersebut dapat memengaruhi ketersediaan atau
                  fungsionalitas Layanan.
                </li>
                <li>
                  Hak Pembatasan Pemrosesan – untuk meminta pembatasan
                  pemrosesan Data Pribadi dalam keadaan tertentu.
                </li>
                <li>
                  Hak Portabilitas Data – untuk meminta pemindahan Data Pribadi
                  mereka ke penyedia layanan lain, sepanjang secara teknis
                  dimungkinkan dan diizinkan oleh hukum.
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="PERNYATAAN DAN JAMINAN ANDA"
              open={openSection === 8}
              onClick={() => handleToggle(8)}
            >
              <p>
                Pengguna dengan tanpa syarat dan tidak dapat ditarik kembali
                menyatakan dan menjamin bahwa:{' '}
              </p>
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Anda telah membaca dan menyetujui Ketentuan-Ketentuan Syarat
                  dan Ketentuan.
                </li>
                <li>
                  Benar Anda memiliki hak hukum penuh, kapasitas dan kewenangan
                  secara hukum untuk mengakses aplikasi atau platform yang
                  ditentukan dan menggunakan Layanan tanpa maksud melanggar
                  ketentuan perundang-undangan yang berlaku.
                </li>
                <li>
                  Semua informasi dan data-data yang telah Anda berikan atau
                  akan Anda berikan kepada kami (termasuk tetapi tidak terbatas
                  pada informasi data pribadi dan kontak) adalah data – data
                  yang akurat dan lengkap serta tidak menyesatkan, Harap tidak
                  mengirimkan setiap Data Pribadi atau data tanpa membaca
                  terlebih dahulu Syarat dan Ketentuan layanan ini yang
                  menjelaskan penggunaan data dan penerapan privasi layanan
                  secara terperinci. Apabila dikemudian hari terdapat bentuk
                  perubahan data-data yang telah Anda berikan kepada kami, maka
                  Anda wajib untuk memberitahukan kepada kami saat perubahan
                  data-data itu, termasuk tetapi tidak terbatas pada Data
                  pribadi yang diperbolehkan untuk perubahan Data Pribadi anda
                </li>
                <li>
                  Anda menjaga kerahasiaan kredensial akun, termasuk nama
                  pengguna, kata sandi, dan kode otentikasi apapun.
                </li>
                <li>
                  Anda wajib untuk segera memberitahukan saluran dukungan yang
                  relevan, apabila terjadi akses tanpa izin atau dugaan
                  penyalahgunaan akun.
                </li>
                <li>
                  Anda memastikan bahwa penggunaan Layanan tidak melanggar hak
                  Mitra, atau pihak ketiga lainnya, termasuk namun tidak
                  terbatas pada hak kekayaan intelektual dan hak privasi.{' '}
                </li>
                <li>
                  Anda bertanggung jawab penuh atas seluruh aktivitas yang
                  dilakukan melalui akun miliknya, baik oleh dirinya sendiri
                  maupun pihak ketiga yang menggunakan kredensialnya.
                </li>
              </ol>
              <p>
                Setiap bentuk pernyataan dan jaminan di atas dibuat dengan
                sebenar-benarnya, tanpa paksaan dari pihak manapun, tanpa
                menyembunyikan fakta dan hal material apapun, maka dengan
                demikian Anda akan bertanggung jawab sepenuhnya atas kebenaran
                dari hal-hal yang telah dinyatakan di atas, anda juga bersedia
                untuk bertanggung jawab baik secara hukum perdata maupun hukum
                pidana, apabila ternyata atas pernyataan dan jaminan tersebut di
                atas ditemukan ketidaksesuaian dengan keadaan yang sebenarnya.
              </p>
            </CollapsibleSection>
            <CollapsibleSection
              title="LARANGAN PENGGUNAAN"
              open={openSection === 9}
              onClick={() => handleToggle(9)}
            >
              <p>
                Dalam menggunakan Layanan, Pengguna dengan tegas dilarang untuk:
              </p>
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Menggunakan Layanan untuk tujuan yang melanggar hukum,
                  penipuan, atau tindakan jahat.
                </li>
                <li>
                  Mencoba mendapatkan akses tanpa izin ke Layanan, sistem,
                  jaringan, atau data milik Pengguna lain.
                </li>
                <li>
                  Mengganggu, merusak, atau menghambat operasi, keamanan, maupun
                  kinerja Layanan.
                </li>
                <li>
                  Mengunggah, mengirimkan, atau menyebarkan konten yang
                  mengandung malware, virus, atau kode berbahaya lainnya.
                </li>
                <li>
                  Melanggar hak kekayaan intelektual, hak privasi, atau hak
                  hukum lainnya milik pihak ketiga.
                </li>
                <li>
                  Menggunakan Layanan dengan cara yang dapat menimbulkan
                  kerugian, kerusakan, atau mencemarkan reputasi Mitra, pihak
                  ketiga terkait, maupun Pengguna lain.{' '}
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="BIAYA DAN PEMBAYARAN"
              open={openSection === 10}
              onClick={() => handleToggle(10)}
            >
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Apabila terdapat biaya yang berlaku, Pengguna akan
                  diberitahukan terlebih dahulu mengenai jumlah biaya, metode
                  pembayaran, siklus penagihan, serta pajak yang berlaku.
                </li>
                <li>
                  Transaksi berlangganan yang telah selesai dilakukan oleh
                  Pengguna tidak dapat dibatalkan, kecuali jika diwajibkan oleh
                  hukum atau secara tegas dinyatakan lain oleh Smartfren.
                </li>
                <li>
                  Mitra berhak untuk menangguhkan atau menghentikan akses
                  Pengguna terhadap Layanan apabila terjadi keterlambatan atau
                  kegagalan pembayaran oleh Pengguna.
                </li>
                <li>
                  Setiap pengembalian dana, potongan harga, atau penawaran
                  promosi tunduk pada syarat dan ketentuan khusus yang
                  diberitahukan oleh Smartfren
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="HAK KEKAYAAN INTELEKTUAL"
              open={openSection === 11}
              onClick={() => handleToggle(11)}
            >
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Seluruh hak kekayaan intelektual yang terkait dengan Layanan,
                  termasuk namun tidak terbatas pada merek dagang, logo, nama
                  domain, perangkat lunak, kode sumber, desain, dan materi
                  kepemilikan lainnya, merupakan hak eksklusif Mitra, kecuali
                  ditentukan lain.
                </li>
                <li>
                  Pengguna diberikan lisensi terbatas, non-eksklusif, tidak
                  dapat dipindahtangankan, dan dapat dicabut untuk menggunakan
                  Layanan hanya untuk kepentingan pribadi dan sah, sesuai dengan
                  Syarat dan Ketentuan ini.
                </li>
                <li>
                  Pengguna tidak diperbolehkan menyalin, memodifikasi,
                  mendistribusikan, menjual, menyewakan, melakukan
                  reverse-engineering, atau mengeksploitasi bagian mana pun dari
                  Layanan tanpa persetujuan tertulis sebelumnya dari Mitra, atau
                  pemilik sah hak kekayaan intelektual tersebut.
                </li>
                <li>
                  Setiap penggunaan hak kekayaan intelektual tanpa izin dapat
                  mengakibatkan penangguhan akses, penghentian Layanan, dan/atau
                  tindakan hukum sesuai dengan ketentuan peraturan yang berlaku.
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="BATAS TANGGUNG JAWAB"
              open={openSection === 12}
              onClick={() => handleToggle(12)}
            >
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Mitra tidak bertanggung jawab atas kerugian tidak langsung,
                  insidental, khusus, punitif, atau konsekuensial yang timbul
                  dari atau sehubungan dengan penggunaan atau ketidakmampuan
                  menggunakan Layanan.
                </li>
                <li>
                  Mitra tidak menjamin bahwa Layanan akan selalu bebas dari
                  kesalahan, gangguan, atau pelanggaran keamanan, dan tidak
                  bertanggung jawab atas kerugian yang timbul karenanya.
                </li>
                <li>
                  Tanggung jawab Layanan, jika ada, terbatas sejauh yang
                  diizinkan oleh hukum yang berlaku di Republik Indonesia.
                </li>
                <li>
                  Pengguna mengakui bahwa penggunaan Layanan dilakukan atas
                  risiko Pengguna sendiri, dan Layanan disediakan dalam kondisi
                  “sebagaimana adanya” dan “sebagaimana tersedia”.
                </li>
              </ol>
              <p>
                Tidak ada dalam Syarat dan Ketentuan ini yang dapat
                mengecualikan atau membatasi tanggung jawab yang secara hukum
                tidak dapat dikecualikan atau dibatasi.
              </p>
            </CollapsibleSection>
            <CollapsibleSection
              title="KEADAAN MEMAKSA"
              open={openSection === 13}
              onClick={() => handleToggle(13)}
            >
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Yang dimaksud dengan Keadaan Memaksa adalah setiap
                  kejadian-kejadian di luar kekuasaan dan di luar kemampuan yang
                  wajar dari Mitra, yang dimana atas kejadian – kejadian
                  tersebut mengakibatkan terjadinya keterlambatan pemenuhan
                  kewajiban di dalam Ketentuan-Ketentuan Penggunaan ini, yang
                  dimana kejadian yang dimaksud antara lain meliputi bencana
                  alam seperti gempa bumi, angin topan, banjir, letusan gunung
                  berapi, epidemi, kebakaran, pemogokan massal, perang,
                  huru-hara, revolusi, kekacauan yang disebabkan keadaan
                  ekonomi, politik, sosial, pemberontakan, perubahan pemerintah
                  secara inkonstitusional, perubahan peraturan
                  perundang-undangan dan perubahan kebijakan Pemerintah di
                  bidang teknologi, ekonomi atau moneter yang secara langsung
                  mempengaruhi Mitra.
                </li>
                <li>
                  Penyedia tidak akan bertanggung jawab atas keterlambatan dalam
                  pemenuhan kewajiban berdasarkan Layanan yang disebabkan oleh
                  Keadaan Memaksa.
                </li>
                <li>
                  Anda menyatakan dan menyetujui untuk tidak menuntut hak apapun
                  sehubungan dengan tidak dapat terlaksananya kewajiban Mitra
                  yang disebabkan oleh terjadinya Keadaan Memaksa.{' '}
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="PENGAKUAN"
              open={openSection === 14}
              onClick={() => handleToggle(14)}
            >
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Anda mengakui bahwa apabila Anda tidak memberikan informasi
                  atau data yang relevan atau menarik persetujuan sehubungan
                  dengan pengumpulan, penggunaan dan/atau pengungkapan informasi
                  atau data yang relevan sebagaimana dijelaskan dalam Syarat dan
                  Ketentuan, Mitra berpeluang untuk tidak dapat membuka atau
                  melanjutkan akun Pengguna, atau membuat atau memberikan atau
                  melanjutkan Layanan. Pengguna akan diberitahu melalui Platform
                  atau saluran resmi yang ditentukan mengenai konsekuensi dari
                  penarikan persetujuan tersebut apabila pengguna mnyampaikan
                  keinginannya untuk menarik persetujuan.
                </li>
                <li>
                  Anda menjamin kepada Mitra bahwa apabila Anda atau kuasa Anda
                  bertanggung jawab atas penyediaan setiap informasi atau data
                  berkaitan dengan siapapun kepada Layanan, atau menyediakan
                  setiap informasi atau data tersebut kepada Mitra, Anda telah
                  memberitahukan dan mendapatkan persetujuan dari orang-orang
                  yang bersangkutan untuk mengizinkan Mitra untuk mengumpulkan,
                  menggunakan, dan/atau mengungkapkan informasi berkaitan dengan
                  orang-orang yang bersangkutan sebagaimana dijelaskan dalam
                  Syarat dan Ketentuan ini.
                </li>
                <li>
                  Anda setuju bahwa Anda telah memperoleh persetujuan dari semua
                  Individu Yang Relevan tersebut sehingga setiap infromasi atau
                  data dari Individu Yang Relevan dapat diolah, disimpan,
                  di-transfer atau diungkapkan dalam dan kepada negara manapun
                  sebagaimana yang dianggap oleh Mitra sesuai dengan hukum yang
                  berlaku untuk tujuan yang diizinkan sebagaimana diatur dalam
                  bagian PENGGUNAAN DATA. Data tersebut juga dapat diproses,
                  disimpan, dipindahkan, atau diungkapkan sesuai dengan hukum,
                  praktik, aturan, dan regulasi setempat (termasuk permintaan
                  apa pun berdasarkan peraturan, tindakan, dan perintah
                  pemerintah) dari negara/yurisdiksi terkait.
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="HUKUM YANG BERLAKU DAN PENYELESAIAN SENGKETA"
              open={openSection === 15}
              onClick={() => handleToggle(15)}
            >
              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  Penafsiran, pelaksanaan, dan segala akibat yang timbul dari
                  Syarat dan Ketentuan ini diatur oleh dan tunduk pada hukum
                  Negara Republik Indonesia.
                </li>
                <li>
                  Apabila terjadi perselisihan dalam pelaksanaan Syarat dan
                  Ketentuan ini, termasuk Perjanjian, maka akan dilakukan
                  penyelesaian secara musyawarah untuk mufakat.
                </li>
                <li>
                  Dalam hal penyelesaian perselisihan melalui musyawarah mufakat
                  dirasa tidak memberikan hasil, maka disepakati untuk
                  menyelesaikan perselisihan melalui Pengadilan Negeri
                  Tangerang.
                </li>
              </ol>
            </CollapsibleSection>
            <CollapsibleSection
              title="CARA MENGHUBUNGI KAMI"
              open={openSection === 16}
              onClick={() => handleToggle(16)}
            >
              <p>
                Anda dapat menghubungi kami melalui Customer Support di Pusat
                Bantuan Smartfren.
              </p>
            </CollapsibleSection>
          </div>
        </main>
      </div>
    </div>
  );
};

interface CollapsibleSectionProps {
  title: string;
  open: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  open,
  onClick,
  children,
}) => (
  <section className="py-4">
    <button
      type="button"
      className={`flex w-full items-center justify-between px-2 py-3 text-left text-lg font-semibold tracking-tight text-slate-900 transition-colors rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 ${
        open ? 'bg-blue-50' : 'hover:bg-slate-100'
      }`}
      aria-expanded={open}
      onClick={onClick}
    >
      <span>{title}</span>
      <svg
        className={`w-5 h-5 ml-2 transition-transform duration-200 ${
          open ? 'rotate-180' : ''
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
    <div
      className={`overflow-hidden transition-all duration-300 ${
        open ? 'max-h-[2000px] opacity-100 mt-3' : 'max-h-0 opacity-0'
      } space-y-3 text-sm leading-relaxed text-slate-700 px-2`}
      aria-hidden={!open}
    >
      {open && children}
    </div>
  </section>
);

export default SmartsecureTermsPage;
